import { Fold, Traversal } from "@discovery/prelude/lib/control/lens";
import * as Optics from "@discovery/sonic-api-ng-optics";
import { mkSiteBuilderComponent, } from "@discovery/template-engine/lib/component-map";
import * as Res from "@discovery/sonic-api-ng/lib/japi/response";
import * as M from "@discovery/prelude/lib/data/maybe";
import { RenderMaybe } from "@discovery/components-luna-react/lib/utils/render-maybe";
import styled from "styled-components";
import { toUndefined } from "fp-ts/Option";
import { SonicImage } from "../../components/atoms/sonic-image";
import { Title } from "../sizzle-reel";
import { media } from "../../styles/breakpoints";
import { useWindowSize } from "../../utils/hooks";
const Container = styled.section `
  width: 100vw;
  max-width: 78vw;
  margin: 0 auto;

  @media ${media.large.down} {
    max-width: 100vw;
  }
`;
const ChannelContainer = styled.div `
  margin: 58px 0px;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  @media ${media.xsmall.down} {
    margin: 25px 0px;
  }
`;
const _NetworkLogosList = Fold.compose(Optics._Col2Items, Optics._ColItem2Channel, Optics._Channel2Images, Traversal._filteredOn(Res._Response(), (image) => image.attributes.kind === "logo"), Res._Response());
const getProps = (data) => {
    const titleM = Fold.view(Optics._ColAttributes2Title, data);
    const imageL = Fold.toArray(_NetworkLogosList, data);
    return { titleM, imageL };
};
const NetworkLogosWrapper = ({ titleM, imageL }) => {
    const [width] = useWindowSize();
    const imageSize = width <= 699 ? 80 : 128;
    return (React.createElement(Container, null,
        React.createElement(RenderMaybe, null, M.map((title) => (title ? React.createElement(Title, null, title) : ""), titleM)),
        React.createElement(ChannelContainer, null, imageL.map((image) => (React.createElement(SonicImage, { key: image.id, format: "PNG", image: image.attributes, fallbackImageSize: { width: 300 }, imageSizes: { default: [imageSize, "px"] }, style: { objectPosition: "center" }, alt: toUndefined(image.attributes.alias) }))))));
};
export const ComponentMapItem = mkSiteBuilderComponent(getProps, NetworkLogosWrapper);

